import { Alert, Button, Text } from '@change/ds-core-ui/next';

import { useEmailDecisionMakerNotification } from './hooks/useEmailDecisionMakerNotification';

export function EmailDecisionMaker() {
	const {
		actions: { handleClick },
	} = useEmailDecisionMakerNotification();

	return (
		<div className="flex h-full w-full gap-4 p-6 pb-0" data-qa="starter-can-email-dm-section-message">
			<Alert className="w-full [&>div>div]:flex-row" variant="info" heading="Contact Your Decision Maker">
				<Text as="p">Emailing decision makers makes it more likely that your petitions will be successful.</Text>
				<Button className="mt-4" size="x-small" variant="secondary-solid" onClick={handleClick}>
					Email your decision maker
				</Button>
			</Alert>
		</div>
	);
}
